import axios from "axios";
import Cookies from "js-cookie";
import {CoachDetails, IUploadRes} from "@/models";
import {checkImageBase64Link, checkImageLink, checkVideoLink, convertBase64ToFile, convertImagesToArr} from "@/utils";
import {API_ENDPOINTS} from "@/constants";

export const handleCoachFilesBeforeUpload = async (
  payload: CoachDetails,
  mainImageIndex: number
) => {
  const finalPayload = {expProof: [], ...payload};
  const {originalImages, croppedImages, video, licenseDoc} = payload;
  const uploadCroppedImagesFiles = [];
  if (Array.isArray(originalImages)) {
    originalImages.forEach((imageItem, index) => {
      const croppedImage = croppedImages[index];
      if (
        typeof croppedImage === 'string' &&
        checkImageBase64Link(croppedImage)
      ) {
        uploadCroppedImagesFiles.push(convertBase64ToFile(croppedImage, index));
      }
    });
  }

  if (
    uploadCroppedImagesFiles?.length > 0 ||
    video instanceof File ||
    licenseDoc instanceof File
  ) {
    const uploadReqPayload = {
      'experience/croppedImage':
        uploadCroppedImagesFiles?.length > 0
          ? uploadCroppedImagesFiles
          : undefined,
      'experience/video': video instanceof File ? video : undefined,
      'user/carLicense':
        licenseDoc instanceof File ? licenseDoc : undefined,
      environment: process.env.REACT_APP_ENVIRONMENT,
    };
    const formData = new FormData();
    for (const key in uploadReqPayload) {
      if (uploadReqPayload[key]) {
        if (Array.isArray(uploadReqPayload[key])) {
          uploadReqPayload[key].forEach(arrItem => {
            formData.append(key, arrItem);
          });
        } else {
          formData.append(key, uploadReqPayload[key]);
        }
      }
    }

    const {data} = await axios.post<IUploadRes>(
      API_ENDPOINTS.uploadService,
      formData,
      {headers: {Authorization: Cookies.get('access_token')}}
    );
    const filesRes = data.uploadedFiles;

    if (filesRes['experience/croppedImage']) {
      finalPayload.expProof = convertImagesToArr(filesRes['experience/croppedImage'],
        mainImageIndex
      ).map(i => i.url);
    }

    if (filesRes['experience/video']) {
      finalPayload.expProof = [...finalPayload.expProof, filesRes['experience/video']?.[0]];
    }

    if (filesRes['user/carLicense']) {
      finalPayload.licenseDoc = filesRes['user/carLicense']?.[0];
    }

  }

  finalPayload.expProof = [
    ...finalPayload.expProof,
    ...originalImages.filter((item) => typeof item === 'string' && checkImageLink(item)) as string[],
    ...(video && typeof video === 'string' && checkVideoLink(video) ? [video] : []),
  ];

  return finalPayload;
};
